import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const TermsOfServicePage: React.FC = () => {
  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Terms of Service" pagesub="Terms of Service" />
            <section className="legal-content py-100">
              <div className="container">
                <div className="legal-content-wrap" style={{ maxWidth: "900px", margin: "0 auto" }}>
                  
                  <p style={{ fontSize: "16px", marginBottom: "30px", color: "rgba(255,255,255,0.7)" }}>
                    <strong>Last updated:</strong> July 04, 2024
                  </p>

                  <h2 style={{ fontSize: "28px", marginTop: "40px", marginBottom: "20px", color: "#fc9038" }}>AGREEMENT TO OUR LEGAL TERMS</h2>
                  
                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    We are <strong>Aquar Labs</strong>, a company registered in India at Aquar Labs, Appughar, Sector 10, MVP Colony Vizag, Andhra Pradesh - 530017
                  </p>

                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    We operate the website <a href="https://www.aquarlabs.com" style={{ color: "#fc9038" }}>www.aquarlabs.com</a>, as well as any other related products and services that refer or link to these legal terms.
                  </p>

                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    These Legal Terms constitute a legally binding agreement made between you, whether personally or on behalf of an entity and Aquar Labs, concerning your access to and use of the Services. You agree that by accessing the Services, you have read, understood, and agreed to be bound by all of these Legal Terms.
                  </p>

                  <div style={{ 
                    background: "rgba(252, 144, 56, 0.1)", 
                    border: "1px solid rgba(252, 144, 56, 0.3)", 
                    borderRadius: "10px", 
                    padding: "20px", 
                    marginBottom: "30px" 
                  }}>
                    <p style={{ lineHeight: "1.8", margin: 0, fontWeight: "600" }}>
                      IF YOU DO NOT AGREE WITH ALL OF THESE LEGAL TERMS, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY.
                    </p>
                  </div>

                  <h2 style={{ fontSize: "28px", marginTop: "40px", marginBottom: "20px", color: "#fc9038" }}>Supplemental Terms and Conditions</h2>
                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    Supplemental terms and conditions or documents that may be posted on the Services from time to time are hereby expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes or modifications to these Legal Terms at any time and for any reason.
                  </p>
                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    We will alert you about any changes by updating the "Last updated" date of these Legal Terms, and you waive any right to receive specific notice of each such change. It is your responsibility to periodically review these Legal Terms to stay informed of updates.
                  </p>
                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    You will be subject to, and will be deemed to have been made aware of and to have accepted, the changes in any revised Legal Terms by your continued use of the Services after the date such revised Legal Terms are posted.
                  </p>

                  <h2 style={{ fontSize: "28px", marginTop: "40px", marginBottom: "20px", color: "#fc9038" }}>Age Requirements</h2>
                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    The Services are intended for users who are at least 13 years of age. All users who are minors in the jurisdiction in which they reside (generally under the age of 18) must have the permission of, and be directly supervised by, their parent or guardian to use the Services.
                  </p>
                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    If you are a minor, you must have your parent or guardian read and agree to these Legal Terms prior to you using the Services.
                  </p>

                  <h2 style={{ fontSize: "28px", marginTop: "40px", marginBottom: "20px", color: "#fc9038" }}>Privacy Policy</h2>
                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    We care about data privacy and security. Please review our Privacy Policy. By using the Services, you agree to be bound by our Privacy Policy, which is incorporated into these Legal Terms.
                  </p>
                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    Please be advised that the Services are hosted in India. By using the Services, you consent to have your data transferred to and processed in India.
                  </p>

                  <h2 style={{ fontSize: "28px", marginTop: "40px", marginBottom: "20px", color: "#fc9038" }}>Contact Us</h2>
                  <p style={{ lineHeight: "1.8", marginBottom: "15px" }}>
                    In order to resolve a complaint regarding the Services or to receive further information regarding use of the Services, please contact us at:
                  </p>
                  
                  <div style={{ 
                    background: "rgba(255, 255, 255, 0.05)", 
                    borderRadius: "10px", 
                    padding: "25px", 
                    marginTop: "20px" 
                  }}>
                    <p style={{ lineHeight: "2", margin: 0 }}>
                      <strong style={{ color: "#fc9038" }}>Aquar Labs LLP</strong><br />
                      Appughar, Sector 10, MVP Colony<br />
                      Vizag, Andhra Pradesh - 530017<br /><br />
                      <strong>Email:</strong> <a href="mailto:info@aquarlabs.com" style={{ color: "#fc9038" }}>info@aquarlabs.com</a><br />
                      <strong>Website:</strong> <a href="https://www.aquarlabs.com" style={{ color: "#fc9038" }}>www.aquarlabs.com</a><br />
                      <strong>Phone:</strong> <a href="tel:+918367036704" style={{ color: "#fc9038" }}>+91 8 3670 3670 4</a>
                    </p>
                  </div>

                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default TermsOfServicePage;
